import React from 'react';
import {View, Sync} from 'MWC';
import tpl from '../templates/list';
import {apiback} from '../../../config';
import {months} from 'utils/dates';
import buildUrl from '../../../helpers/utils/buildGetURLWithParams';
import {environment} from '../../../environment/environment';
import config from '../../../config.json';

const NEWS_PER_PAGE = 3;

export default class extends View {
    template = tpl;

    myRef = React.createRef();
    state = {
        news: [],
        tags: [],
        selectedTags: [],
        isValid: true,
        email: '',
        offset: 0,
        limit: NEWS_PER_PAGE,
        months: [],
        month: null,
        years: [],
        year: null,
        hasDateFilter: false,
        showModal: false,
        result: false
    };

    selectTag = id => {
        const {selectedTags} = this.state;

        if (id === -1) {
            return selectedTags.length && this.setState({news: [], selectedTags: []}, this.getNews);
        }

        const newTagSet = selectedTags.includes(id)
            ? selectedTags.filter(tagId => tagId !== id)
            : [...selectedTags, id];

        this.setState(
            {
                news: [],
                selectedTags: newTagSet,
                offset: 0
            },
            this.getNews
        );
    };

    changePeriod = event => {
        const {target} = event,
            {name} = target.props,
            {value} = target;

        this.setState({[name]: value});
    };

    filterDates = () => {
        this.setState({
            news: [],
            selectedTags: [],
            hasDateFilter: true
        });
        this.getNews();
    };

    resetDate = () =>
        this.setState({
            month: null,
            year: null,
            hasDateFilter: false
        });

    cancelFilter = () => {
        this.resetDate().then(() => this.getNews());
    };

    handleEnter = event => {
        const {isValid, email} = this.state;

        if (event.charCode === 13 && isValid && email.length) {
            this.subscribe();
        }
    };

    handleEmail = event => {
        const email = event.target.value,
            isValid = validateEmail(email);

        this.setState({email, isValid});
    };

    addNews = () => {
        this.myRef.current.style.animation = 'rotate 1s linear infinite';
        this.setState(
            prevState => ({
                offset: prevState.offset + NEWS_PER_PAGE
            }),
            () => this.getNews(true)
        );
    };

    subscribe = async () => {
        const Engine = Sync.getEngine('xhr'),
            url = apiback('API_COREZOID'),
            xhr = new Engine({
                url: `${url}`,
                dataType: 'json',
                type: 'POST',
                contentType: 'application/json',
                data: {
                    conv_data: {
                        email: this.state.email
                    },
                    hash: '656DAB534D7BE93Q'
                },
                cache: false
            });

        try {
            const response = await xhr.post();

            this.setState({result: true});
            this.setState({showModal: true});
            if (response.status !== 'ok') {
                this.setState({result: false});
                throw new Error();
            }

            this.setState({email: ''});
        } catch (error) {
            this.setState({result: false});
            this.setState({showModal: true});
        }
    };

    getTags = () => {
        fetch(apiback('API_NEWS_TAGS_LIST'))
            .then(res => res.json())
            .then(({data}) => this.setState({tags: data}));
        // .catch(x => console.log('error:', x)); //todo добавить обработчик
    };

    getYears = () => {
        fetch(apiback('API_NEWS_DATE_LIST'))
            .then(res => res.json())
            .then(({data}) => {
                const monthsData = {};
                const years = Object.keys(data);
                for (const year of years) {
                    monthsData[year] = [];
                    for (const month of data[year]) {
                        monthsData[year].push(months.find(el => el.id === month));
                    }
                    monthsData[year].sort((a, b) => a.id - b.id);
                }
                this.setState({
                    years: years,
                    months: monthsData
                });
            });
        // .catch(x => console.log('error:', x)); //todo добавить обработчик
    };

    getNews = (add = false) => {
        const {offset, limit, month, year, selectedTags} = this.state,
            prefix = selectedTags.map(tag => `ids[]=${tag}`).join('&'),
            params = {
                offset,
                limit,
                sort_by: ['date'],
                order_by: ['DESC']
            };
        if (month !== null && year !== null) {
            params.month = +month;
            params.year = year;
        }

        const url = buildUrl(apiback('API_NEWS'), params),
            finalUrl = prefix ? url + '&' + prefix : url;

        fetch(finalUrl)
            .then(res => res.json())
            .then(({data, total}) => {
                if (data) {
                    const sortedNews = data.sort((a, b) => new Date(b.date) - new Date(a.date));
                    this.setState(prevState => ({
                        news: add ? [...prevState.news, ...sortedNews] : sortedNews,
                        total
                    }));
                }
                this.myRef.current.style.animation = 'none';
            });
        // .catch(x => console.log('error:', x)); //todo добавить обработчик
    };

    componentDidMount() {
        this.getTags();
        this.getNews();
        this.getYears();
        this.toggleModal = this.toggleModal.bind(this);

        const thisURL = new URL(window.location.href);
        const tagId = 'tagId';
        if (thisURL.searchParams.has(tagId)) {
            this.setState({news: [], selectedTags: []});
            const param = thisURL.searchParams.get(tagId);
            this.selectTag(+param);
        }
    }

    toggleModal() {
        this.setState({showModal: !this.state.showModal});
    }

    changeFilesUrl(url) {
        if (url) {
            if (url.includes('front-assets.a-bank')) {
                return url;
            } else {
                return environment.url + url;
            }
        }
    }

    static displayName = 'News.List';
}

function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}
